const map = {
	"./Arrow-right-thin.svg": 43937,
	"./ArrowLineDown.svg": 19916,
	"./BackArrowicon.svg": 15062,
	"./BgVendor.svg": 54296,
	"./Booking Active.svg": 73282,
	"./Booking Inactive.svg": 40975,
	"./CAR.svg": 56999,
	"./COM[LIACE.svg": 50921,
	"./Calendar.svg": 54321,
	"./CarProfile.svg": 89106,
	"./Charger.svg": 31343,
	"./CheckSquare.svg": 97604,
	"./Clock.svg": 94195,
	"./Compliance.svg": 37522,
	"./ComplianceBlue.svg": 47914,
	"./ComplianceConfig.svg": 20624,
	"./ComplianceConfigBlue.svg": 39948,
	"./ConfigVehicle.svg": 75779,
	"./ConfigVehicleBlue.svg": 63171,
	"./Configure.svg": 61189,
	"./ConfigureBlue.svg": 65937,
	"./CrossBtn.svg": 98831,
	"./Customer.svg": 66703,
	"./CustomerBlue.svg": 10871,
	"./DRIVER BEHAVIOUR.svg": 77976,
	"./Dashboard.svg": 46317,
	"./DashboardBlue.svg": 21833,
	"./Driver.svg": 13065,
	"./DriverBlue.svg": 96221,
	"./FAQ.svg": 92109,
	"./FAQBlue.svg": 40393,
	"./Favicon.png": 96859,
	"./Feedback.svg": 56642,
	"./FeedbackBlue.svg": 51386,
	"./FeedbackConfig.svg": 89984,
	"./FeedbackConfigBlue.svg": 5692,
	"./HYGINE.svg": 83813,
	"./Invoice.svg": 94796,
	"./InvoiceBlue.svg": 75040,
	"./Logout.svg": 29501,
	"./LogoutBlue.svg": 84409,
	"./NewsPaper.svg": 35652,
	"./NoCarImg.svg": 15101,
	"./Notification.svg": 92830,
	"./NotificationBlue.svg": 64334,
	"./OfficeGrey.svg": 42738,
	"./ProfileVendor.svg": 63056,
	"./RateCard.svg": 92103,
	"./RateCardBlue.svg": 26623,
	"./Report.svg": 71573,
	"./ReportBlue.svg": 55265,
	"./RideTrack.svg": 45854,
	"./RideTrackBlue.svg": 89358,
	"./RideTrackCar.svg": 1772,
	"./SAFTEY.svg": 44127,
	"./Service icon.svg": 47347,
	"./Setting.svg": 87069,
	"./SettingBlue.svg": 87321,
	"./Share.svg": 70412,
	"./Snack.svg": 90267,
	"./Star.svg": 91895,
	"./SubVendorLogo.svg": 89152,
	"./Support.svg": 11772,
	"./SupportBlue.svg": 92048,
	"./TableImg.svg": 61862,
	"./Taxi.png": 68127,
	"./Vendor.svg": 25597,
	"./VendorBlue.svg": 13401,
	"./Warning.svg": 22265,
	"./WaterBottle.svg": 96092,
	"./Wifi.svg": 75932,
	"./block.svg": 68058,
	"./blueCar.svg": 86567,
	"./blueLogo.svg": 38186,
	"./calender.svg": 10981,
	"./callLogo.svg": 81870,
	"./camera.svg": 8286,
	"./car-engine.svg": 24014,
	"./car-parts.svg": 36526,
	"./carWheel.svg": 53044,
	"./cardesign.svg": 43333,
	"./checkCircle.svg": 65505,
	"./checklist.svg": 29217,
	"./clapping.svg": 57697,
	"./cloudArrowUp.svg": 51422,
	"./coin.svg": 75792,
	"./companyLogo.svg": 66325,
	"./companyLogoDark.png": 70375,
	"./companyLogoLight.png": 86727,
	"./configure blue.svg": 79639,
	"./cross.svg": 58045,
	"./customerCall.svg": 54835,
	"./deActivate.svg": 23237,
	"./delete.svg": 10154,
	"./dlImg.svg": 71832,
	"./download.png": 25651,
	"./driverImage.png": 6874,
	"./driverVerified.svg": 4437,
	"./drop.svg": 90208,
	"./dropPin.png": 48023,
	"./dummyImg.svg": 11218,
	"./favicon.ico": 30804,
	"./filter.svg": 14969,
	"./fire-extinguisher.svg": 76629,
	"./first-aid-kit.svg": 64089,
	"./gauge.svg": 12924,
	"./greyCall.svg": 49642,
	"./iconMap.svg": 27654,
	"./locationLogo.svg": 50767,
	"./lockicon.svg": 92081,
	"./login_bg.png": 66392,
	"./login_bg.svg": 50972,
	"./login_hand.png": 66434,
	"./logo.png": 82806,
	"./mailLogo.svg": 15967,
	"./mapImage.svg": 63606,
	"./mdStar.svg": 58936,
	"./mechanical.svg": 98594,
	"./menu.svg": 34618,
	"./meter.svg": 98106,
	"./mobile_bg.svg": 88197,
	"./moreDetailsLocation.svg": 29539,
	"./moreEditIcon.svg": 97683,
	"./notificationIcon.svg": 43773,
	"./originPin.png": 48552,
	"./otp_bg.svg": 11348,
	"./pageNotFound.svg": 93059,
	"./pdfImg.svg": 5416,
	"./performance.svg": 2763,
	"./pickUp.svg": 66315,
	"./profileImg.svg": 1643,
	"./searchIcon.svg": 58592,
	"./smCar.svg": 28727,
	"./smEmozy.svg": 97579,
	"./smHealth.svg": 19993,
	"./smLocation.svg": 99550,
	"./smLocationIcon.svg": 75901,
	"./smSaftey.svg": 67471,
	"./smStar.svg": 31623,
	"./tick.svg": 39104,
	"./tickIcon.svg": 55867,
	"./tickmark.svg": 12091,
	"./tripErrorImg.svg": 5229,
	"./vector.svg": 96146,
	"./wallet.svg": 65544,
	"./whiteCar.svg": 72436,
	"./whiteFilter.svg": 212
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;